import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { pageContent } from 'pages/product-details/styles';
import { pdpPageWarningMessageWrapper } from './pdp-page-warning-message.styles';
import { getWarningMessage } from '../ducks/selectors';

export const DATA_QA_PAGE_WARNING_MESSAGE = 'page-warning-message_mf-pdp';

export type PdpPageWarningMessageProps = {
  children?: never;
};

type PageWarningMessageMappedState = {
  text: string | null;
};
type PageWarningMessageConnectedProps = PageWarningMessageMappedState;

function mapStateToProps(state: RootState) {
  return {
    text: getWarningMessage(state),
  };
}

export const PdpPageWarningMessage = connect(mapStateToProps)(({
  text,
  ...restProps
}: PdpPageWarningMessageProps & PageWarningMessageConnectedProps) => {
  return text ? (
    <div
      data-qa={DATA_QA_PAGE_WARNING_MESSAGE}
      className={cx(pageContent, pdpPageWarningMessageWrapper)}
      {...restProps}
    >
      <Typography variant="s" size="body_long" color="text-primary">
        {text}
      </Typography>
    </div>
  ) : null;
});
